import { z } from 'zod';
import { objectIdSchema } from './objectId';
import { DaySchema, TimeSchema } from './time';
import { EventDisplayOption, EventTemplateSchema } from './eventTemplate';
import { AudienceSchema } from './audience';
import { BareStaffAllocationSchema, StaffAllocationSchema } from './staffAllocation';
import { DailyProgramCtaSchema } from './dailyProgramCta';
import { MergedVariablesSchema } from './mergedVars';
import { McmSchema } from './mcm';
import { VenueTemplateSchema } from './venueTemplate';
import { BrandEventHighlightSchema } from './brandEventHighlight';

export const BareEventSchema = z.object({
  _id: objectIdSchema,
  template: objectIdSchema,
  venue: objectIdSchema,
  day: objectIdSchema,
  startTime: TimeSchema,
  duration: z.number(),
  staffAllocations: z.array(BareStaffAllocationSchema),
  hidden: z.boolean(),
  interactiveFeedDisplay: z
    .union([z.enum(EventDisplayOption), z.string()])
    .nullable()
    .optional(),
  venueDisplayName: z.string().optional(),
  deckDisplayName: z.string().optional(),
  callToActions: z.array(DailyProgramCtaSchema),
  templateSourceId: z.union([objectIdSchema, z.string()]).optional(),
  mergedVars: MergedVariablesSchema.optional(),
  imageOverride: z.string().optional(),
  highlights: z.string().array().optional(),
  mcm: McmSchema.optional(),
  audience: AudienceSchema.optional(),
});

export const EventSchema = z.object({
  _id: objectIdSchema,
  template: EventTemplateSchema,
  venue: VenueTemplateSchema,
  day: DaySchema,
  startTime: TimeSchema,
  duration: z.number(),
  staffAllocations: z.array(StaffAllocationSchema), // zod-TODO, should be StaffAllocation[]
  hidden: z.boolean(),
  interactiveFeedDisplay: z.enum(EventDisplayOption).optional(),
  venueDisplayName: z.string().optional(),
  deckDisplayName: z.string().optional(),
  callToActions: z.array(DailyProgramCtaSchema),
  templateSourceId: objectIdSchema,
  mergedVars: MergedVariablesSchema.optional(),
  imageOverride: z.string().optional(),
  highlights: z.array(BrandEventHighlightSchema),
  mcm: McmSchema.optional(),
  audience: AudienceSchema.optional(),
});

export const BareEventWithTitleSchema = BareEventSchema.and(
  z.object({
    title: z.string(),
  })
);

export const EventVenueDisplaySchema = z.object({
  name: z.string(),
  location: z.string(),
  label: z.string(),
  level: z.number(),
  locvenue_locationation: z.string(),
  deck: z.string(),
  venueString: z.string(),
});
